import {reduxForm, getFormValues} from 'redux-form'
import DescriptiveSwitchField from 'components/Fields/ReduxForm/DescriptiveSwitchField'
import RecipientModal from './ReceipientModal'
import * as actEmailNotif from 'actions/setting/emailNotification'
import {connect} from 'react-redux'
import styles from './EmailNotificationForm.css'
import ManageRecipientAlertEmail from './ManageRecipientAlertEmail'
import ListRecipient from './ListRecipient'
import validator from 'validator'

const validate = (values) => {
  const errors = {}
  const settingAlertRecipientsErrors = []
  if (values.settingAlertRecipients) {
    values.settingAlertRecipients.forEach((member, index) => {
      const memberErrors = {}
      // test non-empty string and invalid regex format
      if (member.email && !validator.isEmail(member.email.trim())) {
        memberErrors.email = 'Please enter a valid email address'
        settingAlertRecipientsErrors[index] = memberErrors
      }
    })
  }
  if (settingAlertRecipientsErrors.length) {
    errors.settingAlertRecipients = settingAlertRecipientsErrors
  }
  return errors
}

class EmailNotificationForm extends React.Component {
  render () {
    let {handleSubmit, emailNotificationForm} = this.props

    return (<form onSubmit={handleSubmit}>
      <DescriptiveSwitchField
        label='Daily Sales Summary'
        sublabel='Receive emails about your sales'
        name='dailySalesSummary'
      />
      <div className='hidden'>
        <DescriptiveSwitchField
          label='Product Update'
          sublabel='Stay up to date with new products and features'
          name='productUpdates'
        />
      </div>
      <DescriptiveSwitchField
        label='Inventory Alerts'
        sublabel='Receive daily email of items that are low or out of stock'
        name='inventoryAlerts'
      />
      <DescriptiveSwitchField
        label='Promo Update Notification'
        sublabel='Receive emails at the beginning of next day when a promo is updated'
        additionalText='* Email Notificaton will be sent to Business Owner and Administrator email'
        name='promoUpdateNotif'
      />
      <ManageRecipientAlertEmail />
      <button type='button'
        className={`btn btn-primary ${styles['btn-manage-recipients']}`}
        onClick={this._onClickManageRecipients}>
        Add Email Recipient
      </button>
      {emailNotificationForm && emailNotificationForm.settingAlertRecipients &&
        <ListRecipient
          settingAlertRecipients={emailNotificationForm.settingAlertRecipients}
        />}
      <br />
      <div className='pull-right'>
        <button type='submit' className='btn btn-primary'>Save</button>
      </div>
      <RecipientModal handleSubmit={handleSubmit} />
    </form>)
  }

  _onClickManageRecipients = () => {
    const {emailNotificationForm} = this.props
    this.props.dispatch(actEmailNotif.onClickManageRecipients(emailNotificationForm))
  }
}

let mapForm = {
  form: 'emailNotification',
  validate,
  touchOnBlur: false,
  touchOnChange: false
}

function mapStateToProps (state) {
  return {
    emailNotificationForm: getFormValues('emailNotification')(state)
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(EmailNotificationForm))



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/EmailNotificationForm.js